import 'moment/locale/ja'
import { useTranslation } from "react-i18next";

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import moment from 'moment'

import CustomButton from 'components/CustomButton'
import SectionHeader from 'components/SectionHeader'
import StickyBanner from 'components/StickyBanner'
import { useEvent } from 'hooks/useEvent'
import MainImage from 'components/MainImage'
import Popup from 'components/Popup'

export default function EntryComplete() {
  const { t } = useTranslation();
  const { id } = useParams()
  const { spacing, palette } = useTheme()
  const [event, setEvent] = useState(null)
  const { getEvent, eventResources } = useEvent()
  const [openEntrySuccess, setOpenEntrySuccess] = useState(false)

  moment.locale(process.env.REACT_APP_ACCOUNT_ID === '26' ? 'en-ca' : "ja")

  useEffect(() => {
    getEvent(id).then(eventResource => setEvent(eventResource.event))
  }, [id, getEvent])


  useEffect(() => {
    if (process.env.REACT_APP_ACCOUNT_ID === '41') {
      setOpenEntrySuccess(true)
    }
  }, [])

  if (!event) {
    return null
  }

  return (
    <>
      <div style={{ background: palette.background.paper }}>
        <SectionHeader primary={t("Heading.AppInstallationRequest")} />
        <div style={{ padding: spacing(3) }}>
          <div
            style={{
              padding: spacing(3, 0),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant='body2' style={{ marginBottom: spacing(6) }}>
              {moment(event.start_time).format(process.env.REACT_APP_ACCOUNT_ID === '26' ? 'dddd, MMMM DD, YYYY' : 'YYYY年MM月DD日(ddd)') +
              ' - ' +
              moment(event.end_time).format(process.env.REACT_APP_ACCOUNT_ID === '26' ? 'dddd, MMMM DD, YYYY' : 'YYYY年MM月DD日(ddd)')}
              <br />
              {event.title}
              <br />
                {t("Word.AppliedToParticipateInTheEvent")}
            </Typography>
            <Typography variant='body2' align='center'>
                {t("Message.EntryComplete.InstallationIsRequired")}
            </Typography>
          </div>
        </div>
        <SectionHeader primary={t("Message.EntryComplete.ForFirstTimeParticipants")} />
        <div style={{ padding: spacing(3) }}>
          <div
            style={{
              padding: spacing(3, 0),
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography style={{ fontWeight: 'bold', marginBottom: spacing(3) }} variant='body1'>
                {t("Message.EntryComplete.IfYouDontHaveMeasuringEquipment")}
            </Typography>
              <MainImage
                  src={process.env.REACT_APP_ACCOUNT_ID === '26' ? '/images-static/easy_measurement_en.png' : '/images-static/easy_measurement.png'}
                  alt='' type='description'/>
            <div
              style={{
                padding: spacing(3, 0),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography variant='body2' style={{ marginBottom: spacing(6) }}>
                  {t("Message.EntryComplete.AppInstallationGuide")}
              </Typography>
              <CustomButton
                style={{ marginBottom: spacing(6) }}
                onClick={() => window.open(`https://runtrip-web.onelink.me/Pprx/EventDetail`)}
                arrow
              >
                  {t("Word.InstallRuntripForFree")}
              </CustomButton>
            </div>
          </div>
          <div
            style={{
              padding: spacing(3, 0),
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography style={{ fontWeight: 'bold', marginBottom: spacing(3) }} variant='body1'>
                {t("Heading.EntryComplete.IfYouHaveMeasuringEquipment")}
            </Typography>
              <MainImage
                  src={process.env.REACT_APP_ACCOUNT_ID === '26' ? '/images-static/connect_device_en.png' : '/images-static/connect_device.png'}
                  alt='' type='description'/>
            <div
              style={{
                padding: spacing(3, 0),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography variant='body2' style={{ marginBottom: spacing(6) }}>
                  {t("Message.EntryComplete.IfYouHaveMeasuringEquipment")}
              </Typography>
              <CustomButton
                style={{ marginBottom: spacing(6) }}
                onClick={() => window.open(`https://runtrip-web.onelink.me/Pprx/EventDetail`)}
                arrow
              >
                  {t("Word.InstallRuntripForFree")}
              </CustomButton>
              <Typography style={{ color: palette.link }} variant='body1'>
                <Typography
                  style={{ marginBottom: spacing(3), color: palette.link, cursor: 'pointer' }}
                  onClick={() => window.open(`https://support.runtrip.jp/hc/ja/articles/360055504494`)}
                >
                    {t("Message.EntryComplete.AboutHowToConnectMeasuringDevicesWithTheApp")}
                </Typography>
              </Typography>
            </div>
          </div>
        </div>

        <SectionHeader primary={t("Heading.EntryComplete.ForThoseWhoHaveParticipatedInTheEvent")} />
          <MainImage
              src={process.env.REACT_APP_ACCOUNT_ID === '26' ? '/images-static/confirm_entry_en.png' : '/images-static/confirm_entry.png'}
              alt='' type='description'/>
        <div style={{ padding: spacing(3) }}>
          <div
            style={{
              padding: spacing(3, 0),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant='body2' style={{ marginBottom: spacing(6) }}>
                {t("Message.EntryComplete.OpenTheRuntripAppCndCheckHistory")}
            </Typography>
            <CustomButton
              style={{ marginBottom: spacing(6) }}
              onClick={() => window.open(`https://runtrip-web.onelink.me/Pprx/EventDetail`)}
              arrow
            >
                {t("Word.OpenInApp")}
            </CustomButton>
          </div>
        </div>
      </div>
      {eventResources.length > 1 && (
        <StickyBanner
          actionText="他の種目にエントリーをする"
          actionUrl="/events"
        />
      )}
      {process.env.REACT_APP_ACCOUNT_ID === '41' && (
        <Popup
          open={openEntrySuccess}
          onClose={() => setOpenEntrySuccess(false)}
          title="エントリー完了"
          description= {
          <>
            エントリーありがとうございます！
            <br />
            本イベントは、明治のキャンペーンサイトにエントリーする必要があります。
            <br />
            明治のエントリーがまだの方はエントリーをお願いします。
          </>
          }
          primaryText="明治のエントリーはこちら"
          onClickPrimary={() => {
            window.open('https://campaign.meiji.co.jp/campaignDetail/66544998107506/5715d29c-d100-4c0c-8e19-b76ca99d1caa?from=runtrip2602', '_blank')
            setOpenEntrySuccess(false)
          }}
        />
      )}
    </>
  )
}
